import { Button } from '@mui/material';
import React from 'react';

const CustomButton = ({
    children,
    variant = 'outlined',
    color = 'primary',
    onClick,
    size = 'medium',
    disabled = false,
    startIcon,
    endIcon,
    fullWidth = true,
    marginBottom = '10px'
}) => {
    return (
        <Button
            variant={variant}
            color={color}
            onClick={onClick}
            size={size}
            disabled={disabled}
            startIcon={startIcon}
            endIcon={endIcon}
            fullWidth={fullWidth}
            sx={{
                fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },  // Responsive font sizes
                padding: { xs: '6px 12px', sm: '8px 16px', md: '10px 20px' }, // Adjusted padding
                borderRadius: { xs: 1, sm: 2 },  // Slightly more rounded corners on larger screens
                marginBottom: { xs: 1, sm: marginBottom },  // Reduced margin for mobile
                textTransform: 'none'  // Prevent uppercase for better readability
            }}
        >
            {children}
        </Button>
    );
};

export default CustomButton;
